import React from "react";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PeopleIcon from "@mui/icons-material/People";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { ManageAccountsRounded } from "@mui/icons-material";
import StatCard from "./statCard";
import { Box, Grid, Skeleton } from "@mui/material";
import Link from "next/link";

export default function StatCardWrapper({ data, loading }) {


  return (
    <Box sx={{ marginBottom: 4, boxShadow: 3, borderRadius: 2 }}>
      <Grid
        container
        spacing={2}
        sx={{
          justifyContent: {
            xs: "center",
            sm: "space-between",
          },
          alignItems: "center",
          p: 3,
        }}
      >

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Link href="/property-management">
            <StatCard
              loading={loading}
              title="Property Manager"
              value="120"
              change={data?.property_manager_reserves?.total}
              icon={<ManageAccountsRounded />}
            />
          </Link>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Link href="/property-mapping-manage">
            <StatCard
              loading={loading}
              title="Property Mapping"
              value="200"
              change={data?.property_mappings?.total}
              icon={<PeopleIcon />}
            />
          </Link>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Link href="/account-mapping-manage">
            <StatCard
              loading={loading}
              title="Gl accounts"
              value="30"
              change={data?.gl_account_mappings?.total}
              icon={<AccountTreeIcon />}
            />
          </Link>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Link href="/bank-account-mapping">
            <StatCard
              loading={loading}
              title="Bank Account"
              value="73,000"
              change={data?.bank_account_mappings?.total}
              icon={<AccountBalanceIcon />}
            />
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
}
